import { render, staticRenderFns } from "./ClientsList.vue?vue&type=template&id=1de1d23d&"
import script from "./ClientsList.vue?vue&type=script&lang=js&"
export * from "./ClientsList.vue?vue&type=script&lang=js&"
import style0 from "./ClientsList.vue?vue&type=style&index=0&id=1de1d23d&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1de1d23d')) {
      api.createRecord('1de1d23d', component.options)
    } else {
      api.reload('1de1d23d', component.options)
    }
    module.hot.accept("./ClientsList.vue?vue&type=template&id=1de1d23d&", function () {
      api.rerender('1de1d23d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inventory/warehouse/ClientsList.vue"
export default component.exports